"use client";

import { type FC } from "react";
import { ThreadPrimitive, useAuiState } from "@assistant-ui/react";
import { cn } from "@/lib/utils";
import { useRouteContext } from "@/components/custom/contexts/routeContext";
import { THREAD_STYLE, NO_THREAD_LIST_CLASSES, SHOW_THREAD_LIST_CLASSES } from "./constants";
import { Composer } from "./composer/Composer";
import { ThreadScrollToBottom } from "./composer/ThreadScrollToBottom";
import {
  PdfErrorDialog,
  ThreadWelcome,
  ThreadEmptyStateSuggestions,
} from "./welcome";
import { AnonymizationErrorDialog } from "@/components/custom/AnonymizationErrorDialog";
import { AnonymizationSendWarningModal } from "@/components/custom/anonymizationSendWarningModal";
import { VirtualizedMessagesProvider } from "./VirtualizedMessages";

export const Thread: FC = () => {
  const routeState = useRouteContext();
  const isEmpty = useAuiState((s) => s.thread.isEmpty);

  const footerClasses = routeState.showThreadList === false ? NO_THREAD_LIST_CLASSES : SHOW_THREAD_LIST_CLASSES;

  return (
    <ThreadPrimitive.Root
      className="aui-root aui-thread-root @container flex h-full flex-col bg-background"
      style={THREAD_STYLE}
    >
      {isEmpty ? (
        <div className={cn(
          "aui-thread-viewport relative flex flex-1 flex-col overflow-x-auto overflow-y-auto px-4 pt-4 justify-center",
        )}>
          <ThreadWelcome />
          <PdfErrorDialog />
          <AnonymizationErrorDialog />
          <AnonymizationSendWarningModal />

          <ThreadPrimitive.ViewportFooter className="sticky bottom-0 mx-auto w-full max-w-(--thread-max-width) pb-4 md:pb-6">
            <ThreadEmptyStateSuggestions />
            <Composer />
          </ThreadPrimitive.ViewportFooter>
        </div>
      ) : (
        <VirtualizedMessagesProvider>
          <PdfErrorDialog />
          <AnonymizationErrorDialog />
          <AnonymizationSendWarningModal />
          <ThreadPrimitive.ViewportFooter className={footerClasses}>
            <ThreadScrollToBottom />
            <Composer />
          </ThreadPrimitive.ViewportFooter>
        </VirtualizedMessagesProvider>
      )}
    </ThreadPrimitive.Root>
  );
};
